// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_MkN9-","title":"index_title_y-CcK","cur":"index_cur_7Lg0b"};